// Port de Leyro Avatar.jsx. Mantén render por iniciais cando non hai
// avatarUrl para evitar requests fallidas a `/avatar/<id>`.

export interface AvatarUser {
  name?: string;
  email?: string;
  avatar_url?: string | null;
}

export interface AvatarProps {
  user?: AvatarUser;
  src?: string | null;
  name?: string;
  size?: number;
  className?: string;
}

const PALETTE = [
  'bg-red-400',
  'bg-orange-400',
  'bg-yellow-400',
  'bg-green-500',
  'bg-blue-500',
  'bg-indigo-500',
  'bg-purple-500',
  'bg-pink-500',
];

export default function Avatar({ user, src, name = '', size = 32, className = '' }: AvatarProps) {
  const finalSrc = src ?? user?.avatar_url ?? null;
  const finalName = name || user?.name || user?.email || '';

  const initials = finalName
    .split(' ')
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');

  const colorClass = PALETTE[(finalName.charCodeAt(0) || 0) % PALETTE.length];

  if (finalSrc) {
    return (
      <img
        src={finalSrc}
        alt={finalName}
        className={`rounded-full object-cover ${className}`}
        style={{ width: size, height: size }}
        onError={(e) => {
          (e.currentTarget as HTMLImageElement).style.display = 'none';
        }}
      />
    );
  }
  return (
    <div
      className={`rounded-full flex items-center justify-center text-white font-semibold ${colorClass} ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.38 }}
    >
      {initials || '?'}
    </div>
  );
}
